import { isValidE164Format } from "@/utils/gphonenumberlib";
import { OutboundResponse } from "@/models/outboundresponse";
import { OutboundResponseError } from "@/models/outboundresponserror";
import { ModelValidation } from "@/models/modelvalidation";

export class Demo extends ModelValidation {
    public twilioNumbers: string[] = [
        "+14157921445",
        "+14159929689",
        "+14086179375",
        "+12028385330",
        "+12028399330",
        "+12027937444",
    ];
    public bNumber!: string | null;
    public ttlSeconds!: number | null;
    public maxWaitDuration!: number | null;
    public keepAfterCall!: false;
    public aNumber!: string | null;
    public programContentUuid!: string | null;

    public response = null as OutboundResponse | null;
    public customData = {
        MY_VAR: "",
    };
    // vue variables
    public callResult = null as boolean | null;
    public callHandset = true;
    public destination = "";
    public isCalling = false;
    public isPushing = false;

    constructor(payload: any) {
        super();
        this.bNumber = payload.bNumber || null;
        this.ttlSeconds = payload.ttlSeconds || 16;
        this.maxWaitDuration = payload.maxWaitDuration || 10;
        this.keepAfterCall = payload.keepAfterCall || false;
        this.aNumber = payload.aNumber || null;
        this.programContentUuid = payload.programContentUuid || null;
        this.customData = payload.customData || { MY_VAR: "" };
    }

    public static empty() {
        return new Demo({});
    }

    public toOuboundDto(): any {
        return {
            bNumber: this.bNumber,
            ttlSeconds: this.ttlSeconds,
            maxWaitDuration: this.maxWaitDuration,
            keepAfterCall: this.keepAfterCall,
            aNumbers: [this.aNumber],
            customData: this.customData,
        };
    }

    public get isPushSuccess(): boolean {
        if (!this.response) {
            return false;
        }

        return (
            this.response.responseCode ===
            OutboundResponseError.HandsetReceivedContent
        );
    }

    public get isPushProcessing(): boolean {
        return !this.response;
    }

    public get isPushError(): boolean {
        if (!this.response) {
            return false;
        }

        return (
            this.response.responseCode !==
            OutboundResponseError.HandsetReceivedContent
        );
    }

    public get isCallProcessing(): boolean {
        return this.callResult === null;
    }

    public get isCallSuccess(): boolean {
        return this.callResult !== null && this.callResult;
    }

    public get isCallError(): boolean {
        return this.callResult !== null && !this.callResult;
    }

    public get pushError(): string {
        if (!this.isPushError) {
            return "";
        }

        return this.response!.responseCode!.display;
    }
}
